module.exports = __webpack_public_path__ + "img/shape.e79cdb90.svg";